import React from "react";
import { motion } from "framer-motion";

// Read dark mode directly from localStorage so the preloader gets the
// correct palette even before App.js has mounted its theme useEffect.
function isDark() {
  try { return localStorage.getItem("theme") === "dark"; } catch { return false; }
}

export default function Preloader() {
  const D     = isDark();
  const amber = "#f59e0b";
  const amberL= "#fbbf24";

  // ── Palette — site navy, NOT slate-950 ─────────────────────────────
  const bg        = D ? "#0d1f3c"               : "#f8fafc";
  const trackBg   = D ? "rgba(255,255,255,0.08)": "#e2e8f0";
  const headingC  = D ? "#f0f4f8"               : "#0f172a";
  const subC      = D ? "rgba(240,244,248,0.45)": "#94a3b8";

  return (
    <div style={{
      position:"fixed", inset:0, zIndex:100,
      display:"flex", flexDirection:"column",
      alignItems:"center", justifyContent:"center",
      background: bg, fontFamily:"'Inter',sans-serif",
      transition:"background .3s",
    }}>

      {/* ── Spinner ── */}
      <div style={{ position:"relative", width:84, height:84 }}>

        {/* Static faint track ring */}
        <div style={{
          position:"absolute", inset:0, borderRadius:"50%",
          border:`3px solid ${trackBg}`,
        }}/>

        {/* Amber comet-arc spinner */}
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1.1, ease: "linear" }}
          style={{
            position:"absolute", inset:0, borderRadius:"50%",
            border:"3px solid transparent",
            borderTopColor:   amber,          // leading edge — full amber
            borderRightColor: amberL + "80",  // 50% fade — comet tail start
            borderBottomColor:"transparent",  // invisible
            borderLeftColor:  "transparent",  // invisible
          }}
        />

        {/* Soft amber glow behind the P badge */}
        <div style={{
          position:"absolute", inset:0,
          display:"flex", alignItems:"center", justifyContent:"center",
        }}>
          <motion.div
            animate={{ scale:[1, 1.07, 1] }}
            transition={{ repeat:Infinity, duration:1.8, ease:"easeInOut" }}
            style={{
              width:36, height:36, borderRadius:9,
              background:`linear-gradient(135deg,${amber},${amberL})`,
              display:"flex", alignItems:"center", justifyContent:"center",
              fontWeight:900, fontSize:17, color:"#0d1f3c",
              boxShadow:`0 0 20px ${amber}55`,
              fontFamily:"inherit",
            }}
          >
            P
          </motion.div>
        </div>
      </div>

      {/* ── Brand text — ALL inline styles so no Tailwind JIT issue ── */}
      <motion.div
        initial={{ opacity:0, y:8 }}
        animate={{ opacity:1, y:0 }}
        transition={{ delay:0.25, duration:0.4 }}
        style={{ marginTop:20, textAlign:"center" }}
      >
        {/* PilotLink USA — every character has an explicit color */}
        <div style={{ fontSize:17, fontWeight:800, letterSpacing:".01em", color:headingC }}>
          Pilot
          <span style={{ color:amber }}>Link</span>
          {" "}
          <span style={{ fontSize:11, fontWeight:600, color:subC }}>USA</span>
        </div>

        <motion.p
          initial={{ opacity:0 }}
          animate={{ opacity:1 }}
          transition={{ delay:0.5 }}
          style={{
            marginTop:6, fontSize:11, fontWeight:600,
            letterSpacing:".12em", textTransform:"uppercase",
            color: subC,
          }}
        >
          Loading…
        </motion.p>
      </motion.div>

    </div>
  );
}
